module.exports = __webpack_public_path__ + "static/media/VDM.2ca71afe.png";